<template>
  <div>
    <el-dialog ref="dialog" title="可见条件" size="large" style="min-width:1280px">
      <div>
        <template>
          <el-radio class="radio" v-model="radio" label="close">关闭</el-radio>
          <el-radio class="radio" v-model="radio" label="open">开启</el-radio>
        </template>
        <div class='fl w-120'>可见限制条件</div>
      </div>
      <div v-if='radio == "open"'>
        <div v-for='(titem, $index) in curConditionList' style='margin-left: 120px;' class='m-t-10 m-l-'>
          <el-input 
            v-model="titem.value" 
            class="h-40 w-200 m-l-10 m-r-10" 
            placeholder="请输入值">
          </el-input>
          <el-button type="danger" size="small" @click='deleteCondition($index)'>删除条件</el-button>
          <el-select class='fl' v-model="titem.name" placeholder="请选择" @change='handleChange(titem, $index)'>
            <el-option
              v-for="item in selectSource"
              :label="item.default.title"
              :value="item.default.name">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="addCondition">添加一行</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmConditionList">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog ref="deleteConfirm" title="确认删除条件" v-model="deleteShow">
      <span>确定删除该条件？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
</style>

<script>
  export default {
    props: {
      inputList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        radio: 'close',
        curConditionList: [],
        testvalue: '',
        input: '',
        deleteShow: false,
        selectSource: [],
        groupName: '',
        groupId: 0,
        delCurIndex: 0
      }
    },
    methods: {
      openDialog() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      handleChange(titem, $index) {
        let len = 0
        _(this.curConditionList).forEach((val) => {
          if (val.name == titem.name) {
            len++
            if (len > 1) {
              val.name = ''
              _g.toastMsg(this, 'error', '不能重复选择相同的可见条件项')
              return
            }
          }
        })
      },
      addCondition() {
        this.curConditionList.push({ name: '', value: '' })
      },
      confirmDelete(index) {
        this.curConditionList.splice(this.delCurIndex, 1)
        this.$refs.deleteConfirm.close()
      },
      deleteCondition(index) {
        this.deleteShow = true
        this.delCurIndex = index
      },
      sortConditionList() {
        let comfirm = true
        _(this.curConditionList).forEach((val) => {
          if (val.name == '' || val.value == '') {
            comfirm = false
            _g.toastMsg(this, 'error', '请补充完整内容')
            return
          }
        })
        return comfirm
      },
      getGroupName(item) {
        let self = this
        self.groupName = item.group
        self.groupId = item.group_id
        self.curConditionList = item.condition
        if (item.status == 0) { // 关闭
          // self.curConditionList = []
          self.radio = 'close'
        } else if (item.status == 1) {
          self.radio = 'open'
        }
      },
      confirmConditionList() {
        if (this.radio == 'open') {
          let validate = this.sortConditionList()
          if (validate) {
            this.$emit('setNewConditionList', { condition: this.curConditionList, group_name: this.groupName, group_id: this.groupId, status: 1 })
            this.closeDialog()
          }
        } else {
          this.$emit('setNewConditionList', { condition: [], group_name: this.groupName, group_id: this.groupId, status: 0 })
          this.closeDialog()
        }
      }
    },
    watch: {
      'inputList'(val) {
        var self = this
        self.selectSource = self.inputList
      }
    }
  }
</script>




// WEBPACK FOOTER //
// conditionList.vue?2fa1f212